import { ChevronDown, ChevronUp } from 'react-bootstrap-icons';
import React, { useEffect, useState } from 'react';
// import { FilterOptionValue, MappedFacet } from '@mybestbrands/types';
import styles from './filters.module.scss';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import { FilterOptionValue, MappedFacet } from '@mybestbrands/types';

export function BrandsFilter({
  filter,
  isActive,
  toggleFilterOptions,
  onFilterUpdate,
  onApplySearchFilters,
}: {
  filter: FilterOptionValue | undefined;
  isActive: boolean;

  onApplySearchFilters: () => void;
  onFilterUpdate: (value: string[]) => void;
  toggleFilterOptions: () => void;
}) {
  const { t } = useTranslation('filters');

  const [filterOptions, setFilterOptions] = useState([] as MappedFacet[]);

  const [selectedBrands, setSelectedBrands] = useState([] as string[]);

  useEffect(() => {
    if (!filter) return;
    const selectedBrands = filter.options.filter((option) => option.checked).map((option) => option.value);
    setFilterOptions(filter.options);
    setSelectedBrands(selectedBrands);
  }, [filter?.options]);

  const Chevron = isActive ? ChevronUp : ChevronDown;
  if (!filter) return null;

  function onBrandSelect(id: string) {
    if (selectedBrands.includes(id)) {
      const newSelectedBrands = selectedBrands.filter((brand) => brand !== id);
      setSelectedBrands(newSelectedBrands);
      onFilterUpdate(newSelectedBrands);
    } else {
      setSelectedBrands([...selectedBrands, id]);
      onFilterUpdate([...selectedBrands, id]);
    }
  }

  function onSearchInputChange(e: React.ChangeEvent<HTMLInputElement>) {
    const value = e.target.value.toLowerCase();

    const newFilterOptions = filter?.options.filter((option) => {
      return option.name.toLowerCase().includes(value);
    });

    if (newFilterOptions) setFilterOptions(newFilterOptions);
  }

  return (
    <div
      key={filter.name}
      className="position-relative"
      style={{
        zIndex: 3,
      }}>
      <div
        onClick={toggleFilterOptions}
        key={filter.name}
        className={`btn btn-white-hover-black lowercase d-flex justify-content-center align-items-center ${styles.filter}`}>
        <span className="me-1">{t(filter.name)}</span>
        {!!selectedBrands.length && (
          <span className={`${styles.filtercounter}`}>
            <span className="position-relative" style={{ bottom: '1px' }}>
              {selectedBrands.length}
            </span>
          </span>
        )}
        <Chevron className="ms-2" />
      </div>
      {isActive && (
        <div className={`position-absolute bg-white border border-dark p-2 filter-list`} style={{ top: '35px' }}>
          <div className={`d-flex flex-wrap ${styles.brandscontainer}`} style={{ gap: '0.3rem', paddingBottom: 1 }}>
            <div className="input-group d-inline-flex align-items-end w-100">
              <input
                type="search"
                onChange={onSearchInputChange}
                className={`form-control border-grey w-100 px-2 mb-2 ${styles.brandsearchinput}`}
                placeholder={t('SEARCH_BRANDS')}
                autoCorrect="off"
              />
            </div>

            {filterOptions.map((option) => (
              <div
                onClick={() => onBrandSelect(option.id)}
                key={option.id}
                className="d-flex align-items-center mb-2 w-100"
                style={{ fontSize: '0.775rem' }}>
                <input
                  className="cursor-pointer"
                  name="brands"
                  type="checkbox"
                  checked={selectedBrands.includes(option.id)}
                  onChange={() => {}}
                  style={{ display: 'initial', accentColor: 'transparent' }}
                />
                <label
                  className={clsx(`ms-2 cursor-pointer me-3`, styles.brandoption, option.checked ? 'fw-bold' : '')}>
                  <span className={'me-2'}>{option.name}</span>
                  <span className={styles['filter-badge-gray']}>{option.count}</span>
                </label>
              </div>
            ))}
          </div>
          <div className="position-relative">
            <button
              onClick={onApplySearchFilters}
              className="btn filter btn-white-hover-black lowercase mt-3 mb-2 w-100">
              {t('SAVE')}
              <span className="ms-1" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
